import { render, staticRenderFns } from "./AktarDetay.vue?vue&type=template&id=8beea116&scoped=true"
import script from "./AktarDetay.vue?vue&type=script&lang=ts"
export * from "./AktarDetay.vue?vue&type=script&lang=ts"
import style0 from "./AktarDetay.vue?vue&type=style&index=0&id=8beea116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beea116",
  null
  
)

export default component.exports